/**
 * Distribution-center display — single source of truth for every DC dropdown.
 *
 * Each page used to hardcode its own DC <option> labels (some showed city names,
 * some bare codes, two omitted LA_3PL entirely). Import from here instead so all
 * filters render identically.
 *
 * The first three are AEO-owned DCs; LA_3PL is a third-party-logistics facility.
 * The API still expects the raw code (HZL / MCI / CDC / LA_3PL) — only the label
 * shown to the user is the city.
 */
export const DC_CODES = ['HZL', 'MCI', 'CDC', 'LA_3PL']

const DC_CITY = {
  HZL: 'Hazleton, PA',
  MCI: 'Ottawa, KS',
  CDC: 'Mississauga, ON',
  LA_3PL: 'Los Angeles (3PL)',
}

/**
 * City-name label for a DC code. The "all" sentinel (either 'all' or '') maps to
 * "All DCs"; an unknown code passes through unchanged so nothing silently vanishes.
 */
export function dcLabel(code) {
  if (code === 'all' || code === '' || code == null) return 'All DCs'
  return DC_CITY[code] ?? code
}
